import React, { useState } from 'react';
import baselineSwapVert from "../../assets/icons/signage-plus/baseline-swap-vert.svg";
import TimeEdit from './TimeEdit'
import DeleteButton from './DeleteButton'
import playlistBold from "../../assets/icons/signage-plus/playlist-bold.svg";
import link from '../../assets/icons/signage-plus/link.svg';
import clockIcon from '../../assets/icons/signage-plus/clock-icon.svg';
import weatherIcon from '../../assets/icons/signage-plus/weather-icon.svg';
import calendarIcon from '../../assets/icons/signage-plus/calendar-icon.svg';
import imageIcon from '../../assets/icons/signage-plus/image-icon.svg';
import pngIcon from '../../assets/icons/signage-plus/png-icon.svg';
import jpgIcon from '../../assets/icons/signage-plus/jpg-icon.svg';
import mp4Icon from '../../assets/icons/signage-plus/mp4-icon.svg';
import mp3Icon from '../../assets/icons/signage-plus/mp3-icon.svg';
import pdfIcon from '../../assets/icons/signage-plus/pdf-icon.svg';
import gifIcon from '../../assets/icons/signage-plus/gif-icon.svg';
import canvaFile from '../../assets/icons/signage-plus/canva-file.svg';
import { SIGNAGE_MEDIA, timezome } from '../../utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';

function PlaylistPanelItem(props) {
  const {
    item,
    idx,
    dragOverIndex,
    onDragItemStart,
    onDragOver,
    onDragLeave,
    onDrop,
    playlistOrderMap,
    setPlaylistOrderMap,
    selectedPlaylistId,
    playlistItems
  } = props;

  const currentItems = playlistOrderMap[selectedPlaylistId] || playlistItems || [];
  const [editTimeIdx, setEditTimeIdx] = useState(null)
  const [editTime, setEditTime] = useState({ h: '00', m: '00', s: '10' });
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  // Move forward on the options{ h: '', m: '', s: '' }
  const moveUp = () => {
    if (idx <= 0) return;
    setPlaylistOrderMap(map => {
      const arr = [
        ...(map[selectedPlaylistId]
          || playlistItems
          || [])
      ];
      const [itemMoved] = arr.splice(idx, 1);
      arr.splice(idx - 1, 0, itemMoved);
      return {
        ...map,
        [selectedPlaylistId]: arr.map(i => ({ ...i }))
      };
    });
  };

  // rearward movement
  const moveDown = () => {
    if (idx >= currentItems.length - 1) return;
    setPlaylistOrderMap(map => {
      const arr = [
        ...(map[selectedPlaylistId]
          || playlistItems
          || [])
      ];
      const [itemMoved] = arr.splice(idx, 1);
      arr.splice(idx + 1, 0, itemMoved);
      return {
        ...map,
        [selectedPlaylistId]: arr.map(i => ({ ...i }))
      };
    });
  };

  const handleDeletePlaylist = (id) => {
    setPlaylistOrderMap(map => {
      const newMap = { ...map };
      if (Array.isArray(newMap[selectedPlaylistId])) {
        newMap[selectedPlaylistId] = newMap[selectedPlaylistId].filter(item => item.id !== id);
      } else {
        newMap[selectedPlaylistId] = playlistItems?.filter(item => item.id !== id);
      }
      return newMap;
    });
  };

  const widgeItemText = () => {
    if (
      item.category === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA ||
      item.category !== SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET
    ) {
      const title = (item.updatedAt || item.content?.updatedAt)
        ? `${item.name} (${new Date((item.updatedAt || item.content?.updatedAt) * 1000).toLocaleString()})`
        : item.name;
      return (
        <div
          className="w-100"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "pre",
          }}
          title={title}
        >
          {title}
        </div>
      );
    }

    const subcategoryMap = {
      [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR]: (
        <>
          {t("CALENDAR")}{" "}
          {'(' + timezome[item.content?.paramters?.timeZone] + ')' || ""}
        </>
      ),
      [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK]: (
        <>
          {t("CLOCK")}{" "}
          {item.content?.paramters?.type === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG ? (
            '(' + t("ANALOG") + ')'
          ) : (
            '(' + t("DIGITAL") + ')'
          )}
        </>
      ),
      [SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.WEATHER]: (
        <>
          {t("WEATHER")}{" "}
          {'(' + item.content?.paramters?.city + ')' || ""}
        </>
      ),
    };

    const tem = subcategoryMap[item.subcategory] || item.name;

    return (
      <span
        className="w-100"
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
        }}
      >
        {tem}
      </span>
    );
  };

  const formatDuration = (duration) => {
    const hours = duration >= 3600 ? Math.floor(duration / 3600) : 0;
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = Math.floor(duration % 60);

    return String(isNaN(hours) ? 0 : hours).padStart(2, '0') + ":" +
      String(isNaN(minutes) ? 0 : minutes).padStart(2, '0') + ":" +
      String(isNaN(seconds) ? 0 : seconds).padStart(2, '0');
  };

  const getIconSrc = (item) => {
  if(item.category === SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA) {
    const typeToIconMap = {
      png: pngIcon,
      jpg: jpgIcon,
      mp4: mp4Icon,
      mp3: mp3Icon,
      pdf: pdfIcon,
      gif: gifIcon,
    };
    return typeToIconMap[item.type] || imageIcon;
  }
  if (item.category === SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK) {
    return link;
  }
  if (item.category === SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET) {
    switch (item.subcategory) {
      case SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR:
        return calendarIcon;
      case SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK:
        return clockIcon;
      case SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.WEATHER:
        return weatherIcon;
      default:
        return playlistBold;
    }
  }
  if (item.category === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA) {
    return canvaFile;
  }
  return playlistBold;
};

  const getSeconds = () => {
    const seconds = parseInt(editTime.h) * 3600 + parseInt(editTime.m) * 60 + parseInt(editTime.s);
    return seconds;
  };

  const isInteractiveElement = (target) => {
    if (!target || typeof target.closest !== 'function') return false;
    return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
  };

  return (
    <li
      className="list-group-item d-flex align-items-center justify-content-between h-53"
      key={item.id || idx}
      draggable={editTimeIdx !== idx}
      onDragStart={e => {
        if (editTimeIdx === idx || isInteractiveElement(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        onDragItemStart(e, item.id || idx);
      }}
      onDragOver={e => {
        e.preventDefault();
        if (typeof onDragOver === 'function') onDragOver(e, idx);
      }}
      onDragLeave={onDragLeave}
      onDrop={e => onDrop(e, idx)}
      style={{
        borderTop: '1px solid transparent',
        borderTopColor: dragOverIndex === idx ? '#347BFA' : 'transparent',
        boxSizing: 'border-box'
      }}
    >
      <div className="d-flex align-items-center" style={{ width: 'calc(100% - 220px)' }}>
        <img src={baselineSwapVert} alt="" className="icon icon-16-24" onClick={moveUp} />
        <img
          src={baselineSwapVert}
          alt=""
          className="icon icon-16-24 icon-rotate-180" onClick={moveDown}
        />
        <img
          src={getIconSrc(item)}
          alt=""
          style={{ marginRight: 15, marginLeft: 15 }}
          className="icon icon-24"
        />
        {widgeItemText()}
      </div>
      <div className="d-flex align-items-center">
        {editTimeIdx === idx ? (
          <div className="playlist-time-edit">
            <TimeEdit
              value={editTime}
              onChange={setEditTime}
              onBlur={() => { }}
              onRequestClose={() => setEditTimeIdx(null)}
              onSave={val => {
                const duration = getSeconds();
                setPlaylistOrderMap(map => {
                  let arr = map[selectedPlaylistId] || playlistItems || [];
                  arr = arr.map((item, i) =>
                    i === idx ? { ...item, duration } : item
                  );
                  return {
                    ...map,
                    [selectedPlaylistId]: arr
                  };
                });
              }}
            />
          </div>
        ) : (
          <span
            className="playlist-time"
            onClick={() => {
              setEditTimeIdx(idx)
              const [h = '', m = '', s = ''] = (formatDuration(item.duration)).split(':')
              setEditTime({ h, m, s })
            }}
            style={{ cursor: 'pointer' }}
          >
            {formatDuration(item.duration)}
          </span>
        )}
        <DeleteButton onClick={e => {
          e.stopPropagation();
          handleDeletePlaylist(item.id);
        }} />
      </div>
    </li>
  );
}

export default PlaylistPanelItem;
